import { httpService } from '~/Services/Service';

// Backend (Setpar.APIRest/Startup.cs:53-54) usa SnakeCaseNamingStrategy no JsonFormatter
// — POSTs precisam de snake_case no body. GETs com [FromUri] passam pelo Model Binder
// (case-insensitive), então não precisam conversão.
const camelToSnake = (s) => s.replace(/[A-Z]/g, (m) => `_${m.toLowerCase()}`);

const toSnakeCase = (obj) => {
  if (Array.isArray(obj)) return obj.map(toSnakeCase);
  if (obj === null || typeof obj !== 'object') return obj;
  if (obj instanceof Date) return obj;
  if (obj instanceof FormData) return obj;
  return Object.fromEntries(
    Object.entries(obj).map(([k, v]) => [camelToSnake(k), toSnakeCase(v)])
  );
};

export const listarGruposEmpresaContrato = () =>
  httpService.get('/usuario/lookup/grupos-empresa');

export const listarContasPorGrupoEmpresaContrato = (ge) =>
  httpService.get(`/usuario/lookup/contas-por-ge/${ge}`);

export const obterGridContratos = (filtros) =>
  httpService.get('/controle-contrato/grid', { params: filtros });

export const obterDetalheContrato = (ge, conta, boleto) =>
  httpService.get(`/controle-contrato/${ge}/${conta}/${boleto}`);

export const listarEmpreendimentosContrato = (ge) =>
  httpService.get('/controle-contrato/empreendimentos', { params: { ge } });

export const listarImoveisContrato = (familia) =>
  httpService.get('/controle-contrato/imoveis', { params: { familia } });

export const incluirContrato = (payload) =>
  httpService.post('/controle-contrato/incluir', toSnakeCase(payload));

export const mudarFaseContrato = (payload) =>
  httpService.post('/controle-contrato/mudar-fase', toSnakeCase(payload));

export const alterarItemContrato = (payload) =>
  httpService.post('/controle-contrato/alterar-item', toSnakeCase(payload));

export const anexarDocumentosContrato = (payload) =>
  httpService.post('/controle-contrato/anexar-documentos', toSnakeCase(payload));

export const salvarPendenciasContrato = (payload) =>
  httpService.post('/controle-contrato/salvar-pendencias', toSnakeCase(payload));

export const excluirContrato = (payload) =>
  httpService.post('/controle-contrato/excluir', toSnakeCase(payload));

export const exportarPdfContrato = (filtros) =>
  httpService.get('/controle-contrato/exportar-pdf', {
    params: filtros,
    responseType: 'blob',
  });

export const autoPreencheClienteContrato = (boleto, ge) =>
  httpService.get('/controle-contrato/auto-preenche-cliente', {
    params: { boleto, ge },
  });

// Upload temporário de PDF — retorna { storage_key }
// Limit: 600 KB default; 10 MB se usuario tem caract 257 (Q-10 B)
export const uploadTempContrato = (formData) =>
  httpService.post('/controle-contrato/upload-temp', formData);

